import React, { useEffect, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { uploadLeadFile } from '@/redux/actions';
import { FilesParams } from '@/types';
// import { getFileDetails } from "@/redux/actions";
import { useAppSelector } from '@/hooks';
import { CORRELATION_IDS, selectHttpState } from '@/redux/reducers/http';
import toast from 'react-hot-toast';
import classNames from 'classnames';
import { css } from '@emotion/css';

interface FileUploaderProps {
  onClick?(): void;

  onSuccess?(): void;

  leadsId?: any;
  lostLead?: boolean;
  onProgressChange?(progress: number): void;
}

const FileUploader: React.FC<FileUploaderProps> = (props) => {
  const { lostLead, onProgressChange } = props;
  const fileUploaded = useAppSelector(selectHttpState)[CORRELATION_IDS.UPLOAD_LEAD_FILE];

  const onDrop = useCallback((acceptedFiles: any) => {
    let formData = new FormData();

    if (acceptedFiles && acceptedFiles?.length > 0) {
      acceptedFiles?.forEach((file: any, index: number) => {
        formData.append(`files[${index}]`, acceptedFiles[index]);
      });
    }
    const data: FilesParams = {
      id: props.leadsId,
      formData,
    };
    uploadLeadFile(data, (progressEvent) => {
      const percentageCompleted = Math.round((progressEvent?.loaded * 100) / progressEvent?.total);
      if (onProgressChange) {
        onProgressChange(percentageCompleted);
      }
    });
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  useEffect(() => {
    if (fileUploaded?.success) {
      if (props?.onSuccess) {
        props?.onSuccess();
      }

      if (onProgressChange) {
        onProgressChange(0);
      }
    }
    if (fileUploaded?.error) {
      toast.error('Failed to Upload File');

      if (onProgressChange) {
        onProgressChange(0);
      }
    }
  }, [fileUploaded]);

  return (
    <>
      <section className='container'>
        <div
          {...(!lostLead ? getRootProps() : {})}
          className={classNames({
            dropzone: true,
            [css`
              pointer-events: none !important;
            `]: lostLead,
          })}
        >
          <input {...getInputProps()} />
          <p>Drag & drop</p>
          <p>files or Photos here</p>
          <p>or click to Upload</p>
        </div>
      </section>
    </>
  );
};

export { FileUploader };
